import type { FAQItem } from './types';

export const easeFAQs: FAQItem[] = [
  {
    id: 'user-training',
    question: 'What training and support is provided?',
    answer: `Training is a human-delivered service that varies by service tier:

**Standard Training (All Tiers):**
• Onboarding sessions for all user types
• Written guides
• Email and phone support during business hours
• Platform updates and security patches

**Professional Tier Adds:**
• Priority support with faster response times
• Quarterly business reviews
• Dedicated onboarding specialist

**Enterprise Tier Adds:**
• Dedicated account manager
• Extended support availability
• On-site training and consultation
• Custom training programs

Video tutorial libraries are a design goal, not built yet; training today is delivered live by our team.`,
    category: 'ease',
    featured: true,
  },
  {
    id: 'resident-adoption',
    question: 'How do we get residents to actually use the platform?',
    answer: `Resident adoption depends on immediate value and ease of use. Today, that means:

**Benefits Residents Can Use Now:**
• Vote from home instead of attending meetings
• Access community documents and meeting records anytime
• Message the board directly
• Follow financial transparency views and the event calendar

**Planned, Not Yet Built:**
• Pay dues online
• Submit work orders with photos
• Book facilities online
• Group buying and cost-savings features

**Adoption Strategy:**
• Start with the features that are live today
• Provide simple onboarding materials
• Use community champions to encourage participation

We do not have adoption statistics to share yet; this is a new platform, and any adoption rate we quoted would be a guess, not a track record.`,
    category: 'ease',
  },
  {
    id: 'ongoing-support',
    question: 'What ongoing support is available after implementation?',
    answer: `Ongoing support is a human-delivered service intended to support long-term success:

**All Tiers Include:**
• Business hours email and phone support
• Platform updates and new features
• Security patches and maintenance

**Professional/Enterprise Add:**
• Priority support queues with faster response
• Dedicated account management
• Regular check-ins to optimize platform usage
• Assistance with new feature adoption

A self-serve knowledge base is a design goal, not built yet; support today is delivered directly by our team.`,
    category: 'ease',
  },
  {
    id: 'vendor-training',
    question: 'How do vendors learn to use the system?',
    answer: `Vendor onboarding is a human-delivered service included in implementation. It covers whatever vendor-facing capabilities are live at the time of your rollout.

The vendor portal, bidding system, and rating and review system described elsewhere in this FAQ are planned, not built yet, so vendor training today focuses on communication workflows rather than those tools. Ask us for current build status before scheduling vendor training around a specific feature.`,
    category: 'ease',
  },
];
